module.exports = __webpack_public_path__ + "media/images/flags/dk-f4e8fc5376a202f1d771ff93fab6b2ea.svg";